// extracted by mini-css-extract-plugin
export default {"tab":"dashboard_tab__9oivK"};